import { logger } from '@/config';
import { REVALIDATE_TIME } from '@/constants';

let cachedExclusiveFilters: Record<string, string[]> | null = null;

export async function getExclusiveFilters(): Promise<Record<string, string[]>> {
  if (cachedExclusiveFilters) {
    return cachedExclusiveFilters;
  }

  const BASE_URL = process.env.NEXT_PUBLIC_CDN_LINK;

  if (!BASE_URL) {
    logger.warn('EXCLUSIVE_FILTERS_URL not defined');
    cachedExclusiveFilters = {};
    return cachedExclusiveFilters;
  }

  try {
    const url = `${BASE_URL}/filters/EXCLUSIVE_FILTERS_LIST.json`;
    const res = await fetch(url, {
      next: {
        revalidate: REVALIDATE_TIME,
      },
    });

    if (!res.ok) {
      throw new Error(`Failed to fetch exclusive filters`);
    }

    const data = (await res.json()) as Record<string, string[]>;

    cachedExclusiveFilters = data;
    return data;
  } catch (err) {
    logger.error('Exclusive filters fetch failed', err);
    cachedExclusiveFilters = {};
    return cachedExclusiveFilters;
  }
}
